"use strict";

var isUndefined = require('lodash/isUndefined');

var errors = require('./errors');

var gatherValues = require('./gatherValues');
/**
 * Validates the incoming options object.
 * If something required is missing, lets the user know
 * how to comply with the requirements
 * @param {*} options
 * @throws {Error} when priceTableAssignments is not found
 * @throws {Error} when componentSplitFees is not found
 */


function validateOptions() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (isUndefined(options.priceTableAssignments)) {
    throw new Error(errors.priceTableAssignmentsError);
  }

  Object.keys(options.priceTableAssignments).forEach(function (key) {
    var settings = options.priceTableAssignments[key];

    if (!isUndefined(settings.all)) {
      var possiblePriceTableNames = gatherValues(settings);
      var priceTableNames = settings.all; // that "all" includes at least all of the assigned tables

      if (possiblePriceTableNames.filter(function (name) {
        return priceTableNames.includes(name);
      }).length !== possiblePriceTableNames.length) {
        throw new Error("A price table is missing from \"".concat(key, ".all\": ") + JSON.stringify(possiblePriceTableNames));
      }
    }
  });

  if (isUndefined(options.priceTables)) {
    throw new Error(errors.priceTablesError);
  }
}

module.exports = validateOptions;